import React from 'react';

export  const CaseContext:any = React.createContext(null);
export default CaseContext;

